import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

export const AboutColac = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 sm:py-24 px-6 sm:px-10 bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#F5A623]" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#F5A623] font-semibold">
              About The Bar
            </span>
          </div>

          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#FDFBF7] uppercase leading-[0.95] mb-8">
            The pub in Colac for{" "}
            <span className="text-[#F5A623]">live music and karaoke nights.</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-8 text-[#FDFBF7]/75 text-base sm:text-lg leading-relaxed">
            <p>
              The Bar is Colac's home of <strong className="text-[#FDFBF7] font-semibold">live entertainment every weekend</strong>.
              Tucked into the heart of town on Murray Street, we're the
              Colac bar that turns ordinary weekends into the ones you
              actually remember. Loud crowds, cold drinks and a welcome you
              only get in a country pub.
            </p>
            <p>
              Among the pubs in Colac, we're the one built for big nights — a
              standing-room dance floor, a proper stage for touring acts, and a
              karaoke setup that's seen its share of fearless performances.
              Looking for live music in Colac or a karaoke night to let loose?
              Check the lineup and come join us.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-3 text-sm">
            <MapPin size={16} className="text-[#F5A623]" />
            <span className="text-[#FDFBF7]/70">
              27 Murray Street, Colac VIC 3250 — open Fri & Sat 8pm til late.
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
